import React, { useState } from 'react';
import './CalculatorPage.css'; // Generic CSS for calculator pages

function MoolankCalculator() {
  const [dob, setDob] = useState('');
  const [moolank, setMoolank] = useState(null);
  const [error, setError] = useState('');

  // Function to calculate Moolank (Root Number)
  const calculateMoolank = (dateString) => {
    // Moolank is derived from the day of birth only
    const day = parseInt(dateString.substring(0, 2), 10);

    if (isNaN(day) || day < 1 || day > 31) {
      return null; // Invalid day
    }

    let sum = day;
    // Reduce to a single digit
    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setMoolank(null);

    // Basic validation for DD/MM/YYYY format
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = calculateMoolank(dob);
    if (calculated === null) {
      setError('Invalid date. Please check the day of birth.');
    } else {
      setMoolank(calculated);
    }
  };

  // Explanation for each Moolank number (simplified)
  const getMoolankExplanation = (num) => {
    switch (num) {
      case 1:
        return "Moolank 1: Represents leadership, independence, and strong will.";
      case 2:
        return "Moolank 2: Signifies cooperation, sensitivity, and diplomacy.";
      case 3:
        return "Moolank 3: Denotes creativity, optimism, and self-expression.";
      case 4:
        return "Moolank 4: Symbolizes practicality, hard work, and discipline.";
      case 5:
        return "Moolank 5: Indicates freedom, adventure, and adaptability.";
      case 6:
        return "Moolank 6: Represents responsibility, nurturing, and harmony.";
      case 7:
        return "Moolank 7: Signifies introspection, spiritual growth, and analysis.";
      case 8:
        return "Moolank 8: Denotes ambition, material success, and power.";
      case 9:
        return "Moolank 9: Symbolizes humanitarianism, compassion, and idealism.";
      default:
        return "";
    }
  };

  // JSON-LD Structured Data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Moolank Calculator",
    "description": "Calculate your Moolank (Root Number) based on your birth date and understand its significance in numerology.",
    "url": "https://www.yourwebsite.com/moolank-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Moolank",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/moolank-calculator?dob={dob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=dob"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Moolank Calculator</h1>
      <p className="text-center">Discover your Moolank (Root Number) based on your birth date.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Moolank</button>
      </form>

      {moolank !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Moolank is: <span className="result-number">{moolank}</span></h2>
          <p className="result-explanation">{getMoolankExplanation(moolank)}</p>
        </div>
      )}
    </div>
  );
}

export default MoolankCalculator;
